import { makeAutoObservable } from 'mobx';

class FedexV2EulaStore {
    private _hasScrolledToEnd = false;
    private _acknowledged = false;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    get hasScrolledToEnd() {
        return this._hasScrolledToEnd;
    }

    get acknowledged() {
        return this._acknowledged;
    }

    get canAccept() {
        return this._hasScrolledToEnd && this._acknowledged;
    }

    markScrolledToEnd() {
        this._hasScrolledToEnd = true;
    }

    setAcknowledged(checked: boolean) {
        this._acknowledged = checked;
    }
}

export default FedexV2EulaStore;
